import { render, staticRenderFns } from "./Icase.vue?vue&type=template&id=bb4baf4c&scoped=true"
import script from "./Icase.vue?vue&type=script&lang=js"
export * from "./Icase.vue?vue&type=script&lang=js"
import style0 from "./Icase.vue?vue&type=style&index=0&id=bb4baf4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4baf4c",
  null
  
)

export default component.exports